// @ts-nocheck
/* eslint-disable */
export const appVehicleSocSuccess32Icon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="7" y="7" width="18" height="18" rx="9" fill="currentColor"/><path d="M13.6921 17.3564L15.159 18.3699C15.3294 18.4876 15.563 18.4449 15.6807 18.2745L18.1094 14.759" stroke="#FAFBFB" stroke-width="0.75" stroke-linecap="round"/></svg>`,
    name: 'vehicle-soc-success-32' as const
};